module.exports = __webpack_public_path__ + "img/bluegrey1.9781d8b0.jpg";